import { useEffect, useState } from "react";

export default function useDocumentNumberValidation(type, inputID) {
  const [error, setError] = useState("");
  useEffect(() => {
    if (!error) return undefined;
    const frame = requestAnimationFrame(() => document.getElementById(inputID)?.focus());
    return () => cancelAnimationFrame(frame);
  }, [error, inputID]);

  const handleResponse = (data) => {
    const label = type === "quotation" ? "quote" : type;
    const message = data?.Result_Message;
    const fieldError = data?.Result_Output?.fieldErrors?.[`${type}Number`];
    const duplicate = typeof message === "string" &&
      (message.toLowerCase().startsWith(`this ${label} number already exists.`) ||
        message.toLowerCase().startsWith(`this ${label} number is voided.`));
    const numberError = fieldError || (duplicate ? message : "");
    if (!numberError) return false;
    setError(numberError);
    return true;
  };

  return { error, handleResponse, clearError: () => setError("") };
}
